import Image from 'src/components/atomic/atom/Image'
import Span from 'src/components/atomic/atom/Span'
import Svg from 'src/components/atomic/atom/Svg'
import { COLOR } from 'src/constants/colors'
import { useTranslation } from 'react-i18next'
import warning from 'src/assets/imgs/NoneLocation.png'
import folder_empty from 'src/assets/imgs/explorer_folder_empty.png'
type EmptyComponentProps = {
  ImgMargin?: string
  button?: boolean
  option?: EmptyOptionType
  $margin: string
}
export type EmptyOptionType =
  | 'default'
  | 'ExplorerNoAuth'
  | 'ExplorerOffline'
  | 'LocationNoAuth'
  | 'LocationNoData'
  | 'CameraOffline'
  | 'CameraNoAuth'
  | 'ExplorerNoData'

// offline, No Auth
const EmptyComponent = (props: EmptyComponentProps) => {
  const { t } = useTranslation()
  const EmptyTextList: { [key in EmptyOptionType]: string } = {
    default: '',
    ExplorerNoAuth: t('EXPLORER.ERROR_PERMISSION', {
      defaultValue:
        'Failed to load files/folders from the mobile device. It appears you have not granted MFINDER a “Files and Media” permission.',
    }),
    ExplorerOffline: t('EXPLORER.ERROR_OFFLINE', {
      defaultValue: 'Failed to load files/folders from the mobile device.',
    }),
    LocationNoAuth: t('LOCATE.ERROR_PERMISSION', {
      defaultValue:
        'To locate your lost device, you must have granted MFINDER a ‘location’ permission.',
    }),
    LocationNoData: t('LOCATE.ERROR_DATA', { defaultValue: 'Location data not found' }),
    CameraOffline: t('CAMERA.ERROR_OFFLINE', {
      defaultValue: 'Failed to reach out to your lost device. Device is Off-line.',
    }),
    CameraNoAuth: t('CAMERA.ERROR_PERMISSION', {
      defaultValue:
        'Failed to reach out to your lost device. you must have granted MFINDER “Camera” and “Microphone” permissions.',
    }),
    ExplorerNoData: 'This folder is empty',
  }
  return (
    <>
      {props.option === 'ExplorerNoData' ? (
        <Image $ImgSrc={folder_empty} $margin={props.$margin} width={'80px'} height={'63px'} />
      ) : (
        <Image $ImgSrc={warning} $margin={props.$margin} width={'80px'} height={'80px'} />
      )}
      <Span option={'tiny'} color={COLOR.black30} $margin={'20px auto'}>
        {props.option && EmptyTextList[props.option]}
      </Span>
      {props.button && (
        <Svg
          name={'location_reload'}
          width={'32'}
          height={'32'}
          onClick={() => window.location.reload()}
          $margin={'0 auto'}
        />
      )}
    </>
  )
}
export default EmptyComponent
